.content[data-modal-content] {
    /* Modal.Content also applies its class to the viewport wrapper. */
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.header {
    border-bottom: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;

    @mixin smaller-than $mantine-breakpoint-sm {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: var(--mantine-spacing-sm);
        align-items: start;
    }
}

@mixin smaller-than $mantine-breakpoint-sm {
    .titleGroup {
        grid-column: 1;
        grid-row: 1;
    }

    .closeButton {
        grid-column: 2;
        grid-row: 1;
        width: 44px;
        height: 44px;
    }

    .headerActions {
        grid-column: 1 / -1;
        grid-row: 2;
        min-width: 0;

        :global(.mantine-Button-root) {
            min-height: 44px;
        }
    }
}

.body {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: auto;
}

.actions {
    border-top: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

/* Fullscreen mode */
.fullScreenContent.fullScreenContent {
    /* Mantine puts this class on the viewport-fixed inner AND the content,
       so size both at 100% — the 24px x/yOffset provides the even gutter.
       Doubled class beats Mantine's own auto-sizing content rule. */
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

/* Shift only Mantine's viewport inner below the fixed navbar;
   the dialog content fills the remaining space with 24px gutters. */
:global(body:has(#navbar-header[data-has-visible-fixed-navbar='true']))
    .fullScreenContent.fullScreenContent:not([data-modal-content]) {
    height: calc(100% - var(--navbar-height));
    margin-top: var(--navbar-height);
}

:global(
        body:has(
            #navbar-header[data-has-visible-fixed-navbar='true'][data-has-banner='true']
        )
    )
    .fullScreenContent.fullScreenContent:not([data-modal-content]) {
    height: calc(100% - var(--navbar-height) - var(--banner-height));
    margin-top: calc(var(--navbar-height) + var(--banner-height));
}

.mobileContent.mobileContent {
    display: flex;
    flex-direction: column;
    height: 100dvh;
    width: 100%;
}

@media (width < $mantine-breakpoint-sm), (pointer: coarse) {
    .body :global(.mantine-Input-input) {
        min-height: 44px;
        font-size: 16px;
    }

    .actions :global(.mantine-Button-root) {
        min-height: 44px;
    }
}

@media (max-width: $mantine-breakpoint-sm) {
    .actions {
        flex-wrap: wrap;
        gap: var(--mantine-spacing-sm);
        padding: var(--mantine-spacing-md);
        padding-bottom: max(
            var(--mantine-spacing-md),
            env(safe-area-inset-bottom)
        );
    }
}

/* Full-screen content starts below the navbar; the overlay does too, so the
   navbar is never dimmed behind it. */
:global(body:has(#navbar-header[data-has-visible-fixed-navbar='true']))
    .fullScreenOverlay {
    top: var(--navbar-height);
}

:global(
        body:has(
            #navbar-header[data-has-visible-fixed-navbar='true'][data-has-banner='true']
        )
    )
    .fullScreenOverlay {
    top: calc(var(--navbar-height) + var(--banner-height));
}
